<template>
  <div>
    <!-- <v-select
      v-if="getItemData.new == true"
      :menu-props="{ top: true, offsetY: true }"
      color="secondary"
      class="mx-1 rounded-0"
      item-text="minorNm"
      item-value="minorCd"
      :prepend-inner-icon="$t('$search')"
      :items="riskOrgnGroupList"
      label="역할 선택"
      dense
      v-model="selNewRole"
      @change="chageValue($event)"
      @click.native.stop.prevent="OnPreventClickEvent($event)"
    /> -->
    <!-- {{ getItemData.riskAssRole }} -->
    <div class="text-subtitle-2 font-weight-bold">{{ getItemData.riskAssRoleNm }}</div>
    <!-- <div class="text-subtitle-2 font-weight-bold" v-else>{{ getItemData.riskAssRoleNm }}{{ getItemData.new }}</div> -->
  </div>
</template>
<script>
//function

export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    riskOrgnGroupList: {
      type: Array,
      default: () => {}
    },

    inputValue: Function
  },
  data() {
    return { selNewRole: null }
  },
  computed: {
    getItemData() {
      //console.log('getItemDATa', JSON.stringify(this.itemData))
      return this.itemData
    }
  },
  mounted() {
    //console.log('mounted')
  },
  methods: {
    OnPreventClickEvent(event) {
      //console.log(event)
      event.stopPropagation()
      event.preventDefault()
    },
    chageValue(event) {
      //console.log(event, this.id)
      this.inputValue(this.itemData.riskAssRole, event)
    }
  }
}
</script>
